import { getIn } from "formik";

export const getInForm = (...args: Parameters<typeof getIn>) => {
  return getIn(...args);
};
